var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import ProjectsContext from "../../../application/Context/ProjectsContext";
import MarketsContext from "../../../application/Context/MarketsContext";
import { CleanFilterBtn } from "../doc-lib-components/Views/Filters-styles";
export var CleanFilters = function (_a) {
    var application = _a.application;
    var t = useTranslation(['news']).t;
    var context = application == "markets" ? useContext(MarketsContext) : useContext(ProjectsContext);
    var resertFilters = context.resertFilters, filtersIsLoading = context.filtersIsLoading;
    return (_jsx(React.Fragment, { children: !filtersIsLoading ? _jsxs(CleanFilterBtn, __assign({ onClick: resertFilters }, { children: [" ", t("Effacer les filtres")] })) : _jsx("div", { className: "spinner-border spinner-border-sm", role: "status" }) }));
};
